"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _reactHelmetAsync = require("react-helmet-async");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("../util/styled");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GlobalStyles = (0, _styled.withTheme)((0, _styledComponents.createGlobalStyle)`
  body, html, a, button, input {
    font-family: ${props => props.theme.typography.fontFamily.join(',')};
  }

  body {
    background-color: #fafafa;
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-size: cover;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    margin: 0;
  }

  h1, .h1,
  h2, .h2,
  h3, .h3,
  h4, .h4,
  h5, .h5,
  h6, .h6 {
    font-family: ${props => props.theme.typography.h1.fontFamily};
  }
`);
const BaseLayout = _ref => {
  let {
    children,
    pageTitle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.HelmetProvider, null, /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("meta", {
    name: "viewport",
    content: "minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
  }), /*#__PURE__*/_react.default.createElement("title", null, pageTitle)), /*#__PURE__*/_react.default.createElement(GlobalStyles, null), children);
};
exports.BaseLayout = BaseLayout;
BaseLayout.propTypes = {
  children: _propTypes.default.any,
  pageTitle: _propTypes.default.string
};
BaseLayout.defaultProps = {
  children: [],
  pageTitle: ''
};
var _default = exports.default = BaseLayout;
//# sourceMappingURL=Base.js.map